import * as React from 'react';

/** One row inside the tooltip body. */
export interface TooltipEntry {
  label: string;
  value: string;
  color: string;
}

/** Tooltip content plus its anchor position inside the chart svg. */
export interface ChartTooltipState {
  x: number;
  y: number;
  title: string;
  entries: TooltipEntry[];
}

/** Hover state for chart tooltips driven by invisible hover bands. */
export function useChartTooltip(): {
  tooltip: ChartTooltipState | null;
  show: (state: ChartTooltipState) => void;
  hide: () => void;
} {
  const [tooltip, setTooltip] = React.useState<ChartTooltipState | null>(null);
  const show = React.useCallback((state: ChartTooltipState) => setTooltip(state), []);
  const hide = React.useCallback(() => setTooltip(null), []);

  return { tooltip, show, hide };
}
